import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Gallery from './Gallery';
import MarathiDescription from './MarathiDescription';

// Hero Section Styling Applied
const HeroSection: React.FC = () => {
  return (
   <section
  className="hero-section text-center d-flex align-items-center justify-content-center"
  style={{
    backgroundColor: '#f8f9fa',
    padding: '80px 20px',
    fontFamily: "'Poppins', sans-serif",
    minHeight: '60vh', // thoda height bhi add kar di center alignment ke liye
  }}
>
  <Container>
    <Row className="justify-content-center">
      <Col lg={10}>
        <h1 style={{ fontSize: '2.8rem', fontWeight: 700 }}>
          जीवन आधार फाऊंडेशन
        </h1>
        <p className="lead mb-4" style={{ fontSize: '1.25rem' }}>
          किशोर सलगर यांच्या नेतृत्वाखाली समाजसेवेचा एक अनोखा प्रवास
        </p>
        <Button
          href="#gallery"
          variant="secondary"
          size="lg"
          className="px-4 py-2"
        >
          गॅलरी पहा
        </Button>
      </Col>
    </Row>
  </Container>
</section>

  );
};

// Main Component
const GalleryPage: React.FC = () => {
  const galleryImages = [
    {
      src: "https://i.postimg.cc/BbzhvwNb/900b915b932240a09353b9380978ccc7.jpg",
      alt: "Ahilyaratna Thev Yojana",
      caption: "Ahilyaratna Thev Yojana"
    },
    {
      src: "https://i.postimg.cc/bvNZQstV/Whats-App-Image-2025-06-07-at-20-45-21-6e4d3595.jpg",
      alt: "CLIA पदी निवड झाल्याबद्दल",
      caption: "CLIA पदी निवड झाल्याबद्दल"
    },
    {
      src: "https://i.postimg.cc/QxZCsnHN/IMG-20250530-WA0012.jpg",
      alt: "जीवन आधार फाऊंडेशन कार्यक्रम",
      caption: "जीवन आधार फाऊंडेशन कार्यक्रम"
    },
   
    {
      src: "https://i.postimg.cc/5N50tqCB/IMG-20250530-WA0014.jpg",
      alt: "शैक्षणिक उपक्रम",
      caption: "शैक्षणिक उपक्रम"
    },
    
    {
      src: "https://i.postimg.cc/QC1M1cnr/IMG-20250530-WA0016.jpg",
      alt: "सामाजिक जनजागृती",
      caption: "सामाजिक जनजागृती"
    },
    {
      src: "https://i.postimg.cc/sXtXMTmc/IMG-20250530-WA0017.jpg",
      alt: "महिला सबलीकरण",
      caption: "महिला सबलीकरण"
    },
    {
      src: "https://i.postimg.cc/pdLy4hyD/IMG-20250530-WA0018.jpg",
      alt: "वृक्षारोपण मोहीम",
      caption: "वृक्षारोपण मोहीम"
    },
    {
      src: "https://i.postimg.cc/kg92NhmY/IMG-20250530-WA0019.jpg",
      alt: "स्वच्छता अभियान",
      caption: "स्वच्छता अभियान"
    },
    {
      src: "https://i.postimg.cc/BQ28Kfd1/IMG-20250530-WA0020.jpg",
      alt: "कौशल्य विकास प्रशिक्षण",
      caption: "कौशल्य विकास प्रशिक्षण"
    },
    {
      src: "https://i.postimg.cc/1RknX3YQ/IMG-20250530-WA0021.jpg",
      alt: "शालेय साहित्य वाटप",
      caption: "शालेय साहित्य वाटप"
    },
    {
      src: "https://i.postimg.cc/MXJSS4DC/IMG-20250530-WA0022.jpg",
      alt: "ग्रामीण विकास प्रकल्प",
      caption: "ग्रामीण विकास प्रकल्प"
    },
    {
      src: "https://i.postimg.cc/sX8zn1ZD/IMG-20250530-WA0023.jpg",
      alt: "सामुदायिक कार्यक्रम",
      caption: "सामुदायिक कार्यक्रम"
    },
    {
      src: "https://i.postimg.cc/jjMt7Mxf/IMG-20250530-WA0024.jpg",
      alt: "युवा प्रशिक्षण",
      caption: "युवा प्रशिक्षण"
    },
    {
      src: "https://i.postimg.cc/W3tj60zH/IMG-20250530-WA0025.jpg",
      alt: "सांस्कृतिक कार्यक्रम",
      caption: "सांस्कृतिक कार्यक्रम"
    },
    {
      src: "https://i.postimg.cc/L4w4DQzB/IMG-20250530-WA0027.jpg",
      alt: "आरोग्य जनजागृती",
      caption: "आरोग्य जनजागृती"
    },
    {
      src: "https://i.postimg.cc/02SkBGng/IMG-20250530-WA0028.jpg",
      alt: "शिक्षण प्रोत्साहन",
      caption: "शिक्षण प्रोत्साहन"
    },
    {
      src: "https://i.postimg.cc/NjwsqyCK/IMG-20250530-WA0029.jpg",
      alt: "सामाजिक एकता",
      caption: "सामाजिक एकता"
    },
    {
      src: "https://i.postimg.cc/hGsP0Srf/IMG-20250530-WA0030.jpg",
      alt: "पर्यावरण संवर्धन",
      caption: "पर्यावरण संवर्धन"
    },
    {
      src: "https://i.postimg.cc/sgFXjHxD/IMG-20250530-WA0031.jpg",
      alt: "स्वयंसेवक प्रशिक्षण",
      caption: "स्वयंसेवक प्रशिक्षण"
    },
    {
      src: "https://i.postimg.cc/ZKvnhzTM/IMG-20250530-WA0032.jpg",
      alt: "ग्रामीण विकास",
      caption: "ग्रामीण विकास"
    },
    {
      src: "https://i.postimg.cc/90KfqJBb/IMG-20250530-WA0033.jpg",
      alt: "सामाजिक न्याय",
      caption: "सामाजिक न्याय"
    },
    {
      src: "https://i.postimg.cc/P5mqPbvb/IMG-20250530-WA0034.jpg",
      alt: "शैक्षणिक मार्गदर्शन",
      caption: "शैक्षणिक मार्गदर्शन"
    },
    {
      src: "https://i.postimg.cc/Y92jc496/IMG-20250530-WA0035.jpg",
      alt: "सामुदायिक सहभाग",
      caption: "सामुदायिक सहभाग"
    },
    {
      src: "https://i.postimg.cc/2573Xdzj/IMG-20250530-WA0036.jpg",
      alt: "महिला उद्योजकता",
      caption: "महिला उद्योजकता"
    },
    {
      src: "https://i.postimg.cc/GmY4vwVy/IMG-20250530-WA0037.jpg",
      alt: "युवा सशक्तिकरण",
      caption: "युवा सशक्तिकरण"
    },
    {
      src: "https://i.postimg.cc/ZqSCcszD/IMG-20250530-WA0038.jpg",
      alt: "सामाजिक जागरूकता",
      caption: "सामाजिक जागरूकता"
    },
    {
      src: "https://i.postimg.cc/pXr8hSPf/IMG-20250530-WA0039.jpg",
      alt: "कौशल्य विकास",
      caption: "कौशल्य विकास"
    },
    {
      src: "https://i.postimg.cc/VLhtjFN3/IMG-20250530-WA0040.jpg",
      alt: "शिक्षण प्रसार",
      caption: "शिक्षण प्रसार"
    },
    {
      src: "https://i.postimg.cc/MG2jLKV5/IMG-20250530-WA0041.jpg",
      alt: "सामाजिक एकता",
      caption: "सामाजिक एकता"
    },
    {
      src: "https://i.postimg.cc/GpFsnwjC/IMG-20250530-WA0042.jpg",
      alt: "ग्रामीण विकास",
      caption: "ग्रामीण विकास"
    },
    {
      src: "https://i.postimg.cc/4xh9wh7n/IMG-20250530-WA0043.jpg",
      alt: "सामाजिक कार्यक्रम",
      caption: "सामाजिक कार्यक्रम"
    },
    {
      src: "https://i.postimg.cc/SsV2j651/IMG-20250530-WA0044.jpg",
      alt: "शैक्षणिक उपक्रम",
      caption: "शैक्षणिक उपक्रम"
    },
    {
      src: "https://i.postimg.cc/nrPXGHnv/IMG-20250530-WA0045.jpg",
      alt: "समाजसेवा कार्यक्रम",
      caption: "समाजसेवा कार्यक्रम"
    }
  ];

  return (
    <>
      <HeroSection />
      <div id="gallery">
        <Gallery
          title="आमच्या उपक्रमांची झलक"
          subtitle="सामाजिक, शैक्षणिक आणि आरोग्य क्षेत्रातील कार्य"
          description={<MarathiDescription />}
          images={galleryImages}
        />
      </div>
    </>
  );
};

export default GalleryPage;
